import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    events: []
  },
  getters: {
    getEvents: (state) => state.events
  },
  actions: {
    getAllEvents ({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http.get('https://dcf.wisconsin.gov/rest/childcare/events-spanish?_format=json').then((res) => {
          state.events = res.body
          resolve(true)
        }).catch(() => {
          state.events = [
            {
              title: 'TEST',
              link: '/node/2417',
              start: '2021-10-20T11:19:54',
              body: '\u003Cp\u003Ejunk test\u003C/p\u003E\n',
              end: '2021-10-22',
              location: 'Some test location',
              nid: '2417'
            }
          ]
          resolve(true)
        })
      })
    }
  }
})
